import { appData } from '@/mocks/homeData';

export default function SectionApp() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 bg-background-50 rounded-2xl p-6 md:p-10">
          <div className="flex-shrink-0 w-40 md:w-48">
            <div className="aspect-[3/4] rounded-2xl overflow-hidden bg-background-200">
              <img
                src={appData.image}
                alt="91免费在线视频移动客户端"
                className="w-full h-full object-cover"
                onError={(e) => {
                  const target = e.currentTarget;
                  target.style.display = 'none';
                }}
              />
            </div>
          </div>

          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-black text-foreground-950 font-heading mb-3">
              移动观影
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-5">
              {appData.desc}
            </p>
            <div className="grid grid-cols-2 gap-2 mb-6">
              {appData.features.map((feat, i) => (
                <div key={i} className="flex items-center gap-2 text-sm text-foreground-700">
                  <span className="w-5 h-5 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 flex-shrink-0">
                    <i className="ri-check-line text-xs"></i>
                  </span>
                  <span className="whitespace-nowrap">{feat}</span>
                </div>
              ))}
            </div>
            <div className="flex items-center gap-3 justify-center lg:justify-start flex-wrap">
              <a
                href="#app"
                className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 bg-foreground-950 text-background-50 rounded-lg font-semibold text-sm hover:bg-foreground-800 transition-colors cursor-pointer"
              >
                <i className="ri-apple-fill text-lg"></i>
                App Store
              </a>
              <a
                href="#app"
                className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-lg font-semibold text-sm hover:bg-primary-600 transition-colors cursor-pointer"
              >
                <i className="ri-android-fill text-lg"></i>
                Android 下载
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}